export default "__VITE_ASSET__77bdda3f__"